"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddSpacingBeforeParagraphCommand = void 0;
var tslib_1 = require("tslib");
var paragraph_properties_1 = require("../../../core/model/paragraph/paragraph-properties");
var unit_converter_1 = require("@devexpress/utils/lib/class/unit-converter");
var add_spacing_after_paragraph_command_1 = require("./add-spacing-after-paragraph-command");
var AddSpacingBeforeParagraphCommand = (function (_super) {
    tslib_1.__extends(AddSpacingBeforeParagraphCommand, _super);
    function AddSpacingBeforeParagraphCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AddSpacingBeforeParagraphCommand.prototype.getDescriptor = function () {
        return paragraph_properties_1.ParagraphPropertyDescriptor.spacingBefore;
    };
    AddSpacingBeforeParagraphCommand.prototype.isEnabled = function () {
        return _super.prototype.isEnabled.call(this) && this.getCurrentValue() === 0;
    };
    AddSpacingBeforeParagraphCommand.prototype.DEPRECATEDConvertOptionsParameter = function (parameter) {
        return parameter == null ? unit_converter_1.UnitConverter.pointsToTwips(12) : parameter;
    };
    return AddSpacingBeforeParagraphCommand;
}(add_spacing_after_paragraph_command_1.LineSpacingParagraphCommandBase));
exports.AddSpacingBeforeParagraphCommand = AddSpacingBeforeParagraphCommand;
